<template>
    <div>
        <Modal v-model="modelShow" title="出入库流水" width="80%" @on-visible-change="onVisibleChange">
            <Form ref="formValidate" :label-width="100" inline>
                <FormItem label="标的物小类">
                    <targetTypeCascader v-model="queryParams.targetType"/>
                </FormItem>
                <FormItem label="品质类型">
                    <dict-select v-model="queryParams.qualityType" namespace="ENUM_CORE-STORAGE" id="operateService.QualityType" :exclusion="[]"/>
                </FormItem>
                <FormItem label="用途类型">
                    <dict-select v-model="queryParams.useType" namespace="ENUM_CORE-STORAGE" id="operateService.UseType" :exclusion="[]"/>
                </FormItem>
                <FormItem label="出入库类型">
                    <dict-select v-model="queryParams.operateType" namespace="ENUM_CORE-STORAGE" id="operateService.OperateType" :exclusion="[]"/>
                </FormItem>
                <FormItem label="流水时间">
                    <DatePicker :value="[queryParams.startDate,queryParams.endDate]" type="daterange" placement="bottom-end" placeholder="请选择时间范围" @on-change="onDateChang" style="width: 200px" transfer></DatePicker>
                </FormItem>
                <Button type="primary" style="margin-left:20px" @click="getQuery">查询</Button>
            </Form>
            <!-- 列表 -->
            <div class="table">
                <data-grid ref="dg" :columns="cols" :queryParams="queryParams" paramsName="param"  :pageSize="20" :autoLoad="false" :queryUrl="queryUrl"></data-grid>
            </div>
        </Modal>
    </div>
</template>
<script>
import dataGrid from '@/components/datagrid.vue';
import dictSelect from '@/components/select/dict-select.vue';
import targetTypeCascader from '@/components/select/targetType-cascader.vue';
export default {
    props : ['params'],
    components: {
        dataGrid,
        dictSelect,
        targetTypeCascader
    },
    data(){
        return {
            queryUrl : 'http://CORE-STORAGE/messageService/operateService/queryInventoryFlowList',
            cols: [
                {title: '仓库', key: 'storageId', dict: ['bizObjects', 'warehouse',true]  },
                {title: '标的物小类', key: 'targetType', dict: ['target', 'type',true]},
                {title: '标的物编码', key: 'targetCode', dict: ['target', 'targetCodeUnion',true] },
                {title: '用途类型', key: 'useType',dict: ['ENUM_CORE-STORAGE', 'operateService.UseType'] },
                {title: '品质类型', key: 'qualityType',dict: ['ENUM_CORE-STORAGE', 'operateService.QualityType'] },
                {title: '数量', key: 'numEffect' },
                {title: '出入库类型', key: 'operateType',dict: ['ENUM_CORE-STORAGE', 'operateService.OperateType'] },
                {title: '出入库时间', key: 'occurTime' ,formatter:'date'},
                {title: '备注', key: 'remark',width:300 },
            ],
            modelShow : false,
            queryParams : {
                storageId : ''
            }
        }
    },
    mounted(){

    },
    methods : {
        openModal() {
            this.modelShow = true
        },
        getQuery(){
            this.$refs['dg'].loadFirstPage()
        },
        onDateChang(val){
            this.queryParams.startDate = val[0];
            this.queryParams.endDate = val[1];
        },
        onVisibleChange(visible){
            if(visible){
                this.queryParams.storageId = this.params.storageId
                setTimeout(()=>{
                    this.$refs['dg'].loadFirstPage()
                },50)
            }else{
                this.queryParams = {}
            }
        }
    }
}
</script>